export default "__VITE_ASSET__e6KYoP4r__"